import { api } from "./configs/axiosConfig";
import { defineCancelApiObject } from "./configs/axiosUtils";

export const showHouseApi = {
  getShowHousePending: async function ({trackingSysId, houseNum, houseYear},
    cancel = false
  ) {
    const response = await api.request({
      url: `/HouseExibicao/showHouseForm?trackingSysId=${trackingSysId}&houseNum=${houseNum}&houseYear=${houseYear}`,
      method: "GET",
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });
    return response.data.data;
  },
};

const cancelApiObject = defineCancelApiObject(showHouseApi);
